import Axios from 'axios'
import {Urls} from './Urls'

const Adb2cRedirectUrl = process.env.REACT_APP_Adb2cConfig_TenantRedirectUrl;
const Adb2cApplicationId = process.env.REACT_APP_Adb2cConfig_TenantId;

export const Activity = (data) => {

  return Axios.post(Urls.logURL, { "activity": "Session Logging", "application": "Lorri", "ip": sessionStorage.getItem("ClientIP"), "session_log": data })

}
export const Constants = {
  MapBox: {
    AccessToken:
      'pk.eyJ1IjoiYW5hbHl0aWNzbG4iLCJhIjoiY2p0eWFrbzJ4MGZ6czRkcG5tc3hka3A3MiJ9.3iT-wbkITehGa-nhf5AgTw'
  },

  Pagination: {
    PageSize: 1000
  },

  Ratings: {
    OutOf: 5
  },

  StaffJsonMap: [
    { key: 'management_staff', label: 'Management' },
    { key: 'maintenance_staff', label: 'Maintainance' },
    { key: 'driver', label: 'Driver' }
  ],

  Adb2cConfig: {
    Tenant: {
      id: Adb2cApplicationId,
      name: 'logisticsnowtech.onmicrosoft.com',
      redirectUrl: Adb2cRedirectUrl
    },
    ForgotPassword: {
      code: 'AADB2C90118',
      url:
        'https://logisticsnowtech.b2clogin.com/logisticsnowtech.onmicrosoft.com/oauth2/v2.0/authorize?' +
        'p=B2C_1_password_reset' +
        '&client_id=' +
        Adb2cApplicationId +
        '&nonce=defaultNonce' +
        '&redirect_uri=' +
        Adb2cRedirectUrl +
        '&scope=openid' +
        '&response_type=id_token' +
        '&prompt=login'
    },
    EditProfile: {
      code: 'AADB2C90118',
      url:
        'https://logisticsnowtech.b2clogin.com/logisticsnowtech.onmicrosoft.com/oauth2/v2.0/authorize?' +
        'p=B2C_1_edit_profile' +
        '&client_id=' +
        Adb2cApplicationId +
        '&nonce=defaultNonce' +
        '&redirect_uri=' +
        Adb2cRedirectUrl +
        '&scope=openid' +
        '&response_type=code' +
        '' //'&prompt=login'
    },
    CancelButtonErrorCode: 'AADB2C90091'
  },
  Email: {
    regex: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  },

  FileHandlerActions: {
    Upload: 'upload',
    Download: 'download'
  }

};

export const Sectors = [
  {
    name: 'AGRICULTURAL PRODUCTS',
    value: { isChecked: false },
    displayName: 'AGRICULTURAL PRODUCTS'
  },
  {
    name: 'AUTOMOBILE',
    value: { isChecked: false },
    displayName: 'AUTOMOBILE'
  },
  { name: 'BREWING', value: { isChecked: false }, displayName: 'BREWING' },
  {
    name: 'BUILDING MATERIAL',
    value: { isChecked: false },
    displayName: 'BUILDING MATERIAL'
  },
  { name: 'CEMENT', value: { isChecked: false }, displayName: 'CEMENT' },
  { name: 'CERAMICS', value: { isChecked: false }, displayName: 'CERAMICS' },
  { name: 'CHEMICAL', value: { isChecked: false }, displayName: 'CHEMICAL' },
  {
    name: 'CONSTRUCTION',
    value: { isChecked: false },
    displayName: 'CONSTRUCTION'
  },
  { name: 'ECOMMERCE', value: { isChecked: false }, displayName: 'ECOMMERCE' },
  {
    name: 'ELECTRICALS',
    value: { isChecked: false },
    displayName: 'ELECTRICALS'
  },
  {
    name: 'ELECTRONICS',
    value: { isChecked: false },
    displayName: 'ELECTRONICS'
  },
  {
    name: 'ENGINEERING SERVICES',
    value: { isChecked: false },
    displayName: 'ENGINEERING SERVICES'
  },
  {
    name: 'FASHION AND CLOTHING',
    value: { isChecked: false },
    displayName: 'FASHION AND CLOTHING'
  },
  { name: 'FMCD', value: { isChecked: false }, displayName: 'FMCD' },
  { name: 'FMCG', value: { isChecked: false }, displayName: 'FMCG' },
  { name: 'GLASS', value: { isChecked: false }, displayName: 'GLASS' },
  {
    name: 'HEALTHCARE',
    value: { isChecked: false },
    displayName: 'HEALTHCARE'
  },
  {
    name: 'INDUSTRIAL AUTOMATION',
    value: { isChecked: false },
    displayName: 'INDUSTRIAL AUTOMATION'
  },
  {
    name: 'INFRASTRUCTURE',
    value: { isChecked: false },
    displayName: 'INFRASTRUCTURE'
  },
  { name: 'LOGISTICS', value: { isChecked: false }, displayName: 'LOGISTICS' },
  { name: 'LUGGAGE', value: { isChecked: false }, displayName: 'LUGGAGE' },
  {
    name: 'MANUFACTURING',
    value: { isChecked: false },
    displayName: 'MANUFACTURING'
  },
  // {name:'MANUFACTURING EXECUTION SYSTEM', value:{isChecked:false}, displayName:'MANUFACTURING EXECUTION SYSTEM'},
  {
    name: 'METALS AND MINING',
    value: { isChecked: false },
    displayName: 'METALS AND MINING'
  },
  {
    name: 'OIL AND GAS',
    value: { isChecked: false },
    displayName: 'OIL AND GAS'
  },
  { name: 'PACKAGING', value: { isChecked: false }, displayName: 'PACKAGING' },
  { name: 'PAINTS', value: { isChecked: false }, displayName: 'PAINTS' },
  { name: 'PAPER', value: { isChecked: false }, displayName: 'PAPER' },
  {
    name: 'PHARMACEUTICAL',
    value: { isChecked: false },
    displayName: 'PHARMACEUTICAL'
  },
  { name: 'PLASTICS', value: { isChecked: false }, displayName: 'PLASTICS' },
  {
    name: 'PRINTING AND MINTING',
    value: { isChecked: false },
    displayName: 'PRINTING AND MINTING'
  },
  {
    name: 'RAW MATERIAL',
    value: { isChecked: false },
    displayName: 'RAW MATERIAL'
  },
  { name: 'STEEL', value: { isChecked: false }, displayName: 'STEEL' },
  {
    name: 'TECHNOLOGY',
    value: { isChecked: false },
    displayName: 'TECHNOLOGY'
  },
  { name: 'TELECOM', value: { isChecked: false }, displayName: 'TELECOM' },
  { name: 'TEXTILE', value: { isChecked: false }, displayName: 'TEXTILE' },
  { name: 'TYRE', value: { isChecked: false }, displayName: 'TYRE' }
];

export const Countries = [
  {
    code: 'IN',
    name: 'India',
    value: { isChecked: false },
    displayName: 'India',
    flagUrl: '/static/media/in.7fdfdb85.svg'
  },
  {
    code: 'AU',
    name: 'Australia',
    value: { isChecked: false },
    displayName: 'Australia',
    flagUrl: '/static/media/au.ecef4318.svg'
  }
];

export const Zones = [
  { name: 'East', value: { isChecked: false }, displayName: 'East' },
  { name: 'West', value: { isChecked: false }, displayName: 'West' },
  { name: 'North', value: { isChecked: false }, displayName: 'North' },
  { name: 'South', value: { isChecked: false }, displayName: 'South' },
  {
    name: 'Northeast',
    value: { isChecked: false },
    displayName: 'Northeast'
  }
];

export const RatingParameters = [
  {
    id: 'Reliability',
    name: 'Reliability',
    rating: 0,
    description: 'How reliable is the transporter?'
  },
  {
    id: 'Season/ad-hocSupport',
    name: 'Season/ad-hoc Support',
    rating: 0,
    description: 'Ability to support in Season/ad-hoc requirements'
  },
  {
    id: 'ServiceLevelAdherence',
    name: 'Service Level Adherence',
    rating: 0,
    description: 'On-time and efficient truck placement'
  },
  {
    id: 'CostCompetitiveness',
    name: 'Cost Competitiveness',
    rating: 0,
    description: 'How competitive are this transporters rates?'
  }
];

export const VASParameters = [
  {
    id: 1,
    class: 'fa fa-star raiting-icon-color',
    name: 'Get Industry Ratings for your Transporters'
  },
  {
    id: 2,
    class: 'fa fa-industry industry-icon-color',
    name: 'Discover Industry Benchmarks'
  },
  {
    id: 3,
    class: 'fa fa-truck logistic-partner-icon-color',
    name: 'Find your Right Logistics Partner'
  },
  {
    id: 4,
    class: 'fa fa-cogs explorer-icon-color',
    name: 'Request for Information(RFI) for Transporters'
  }
];

export const RoutePaths = {
  MyAccount: '/myAccount'
};
export const encryptor = (transporterID = '', shouldEncode) => {
  let characters = "QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm".split("")
  const generateRandomCharcter = () => characters[Math.floor(Math.random() * characters.length)];
  if (shouldEncode) {
    let k = transporterID.split("")
    let encodedID = ""
    k.map((item, index) => {
      encodedID += item;
      for (let i = 0; i <= index; i++) {
        encodedID += generateRandomCharcter();
      }
    })
    return encodedID
  }
  else {
    let decodedID = ""
    let startIndex = 0, nextIndex = 2
    while (transporterID.length > startIndex) {
      decodedID += transporterID[startIndex];
      startIndex += nextIndex;
      nextIndex++;
    }
    return decodedID
  }



}
